"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlService = void 0;
var app_1 = require("app");
var UrlService = /** @class */ (function () {
    function UrlService() {
        var _this = this;
        this.regexFileUrl = /^([\S]+)(\.(pdf|zip|dwg|dxf|((doc|ppt|xls)(x?))))(\?[\S]+)?$/i;
        this.matchExtension = /(\.(pdf|zip|dwg|dxf|((doc|ppt|xls)(x?))))(\?[\S]+)?$/i;
        this.CreateQueryObject = function (pairs) {
            return (0, app_1.safe)(pairs).reduce(function (acc, next) {
                var _a;
                if (!next.key) {
                    return acc;
                }
                return __assign(__assign({}, acc), (_a = {}, _a[next.key] = next.value, _a));
            }, {});
        };
        this.isUrlParameterChanged = function (obj) {
            var urlObj = _this.GetObjectFromUrlString();
            if (!_this.isValueChanged(obj.value, urlObj[obj.key])) {
                return false;
            }
            return true;
        };
        this.isFilterSelected = function (filter) {
            var urlObject = _this.GetObjectFromUrlString();
            if (!urlObject.filter || urlObject.filter.indexOf(filter) === -1) {
                return false;
            }
            return true;
        };
        this.GetSourceUrl = function () {
            var origin = window.location.origin ||
                window.location.protocol + "//" + (window.location.port ? ":" + window.location.port : "");
            var query = window.location.href.indexOf("?") === -1
                ? ""
                : window.location.search
                    ? window.location.search
                    : window.location.href.slice(window.location.href.indexOf("?"));
            if (query.indexOf("#") !== -1) {
                query = query.slice(0, query.indexOf("#"));
            }
            var url = origin + window.location.pathname + query;
            return url;
        };
        this.isValueChanged = function (value, previousValue) {
            return (!previousValue && !!value) || // added new value
                (previousValue && previousValue !== value); // page value changed
        };
        this.decodeFiltersForGTM = function (filters) {
            if (!filters || !filters.length) {
                return filters;
            }
            return filters.map(function (filter) {
                return typeof filter === "string"
                    ? decodeURIComponent(filter).replace("=", ":")
                    : filter;
            });
        };
    }
    UrlService.prototype.GetObjectFromUrlString = function (url) {
        if (url === void 0) { url = window.location.search; }
        if (url.length === 0 || url.indexOf("=") === -1) {
            return {};
        }
        else {
            var arr = url.slice(1, url.length).split("&");
            var obj = {};
            for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
                var item = arr_1[_i];
                obj[item.split("=")[0]] = decodeURIComponent(item.split("=")[1]);
            }
            return obj;
        }
    };
    UrlService.prototype.GetStringFromUrlObj = function (obj) {
        var str = "?";
        for (var i in obj) {
            str += ("".concat(i, "=").concat(encodeURIComponent(obj[i]), "&"));
        }
        return str.slice(0, -1);
    };
    UrlService.prototype.AddToUrl = function (obj, replace) {
        if (replace === void 0) { replace = true; }
        if (!obj.value) {
            return this.RemoveFromUrl(obj.key, replace);
        }
        var urlObj = this.GetObjectFromUrlString();
        if (!this.isValueChanged(obj.value, urlObj[obj.key])) {
            return false;
        }
        urlObj[obj.key] = obj.value;
        var urlStr = this.GetStringFromUrlObj(urlObj);
        if (replace) {
            window.history.replaceState(urlObj, null, urlStr);
            return false;
        }
        else {
            window.history.pushState(urlObj, null, urlStr);
            return true;
        }
    };
    UrlService.prototype.RemoveFromUrl = function (key, replace) {
        if (replace === void 0) { replace = true; }
        var urlObj = this.GetObjectFromUrlString();
        if (!urlObj.hasOwnProperty(key)) {
            return false;
        }
        delete urlObj[key];
        var urlStr = this.GetStringFromUrlObj(urlObj);
        if (replace) {
            window.history.replaceState(urlObj, null, urlStr.length > 0 ? urlStr : document.location.pathname);
            return false;
        }
        else {
            window.history.pushState(urlObj, null, urlStr.length > 0 ? urlStr : document.location.pathname);
            return true;
        }
    };
    UrlService.prototype.CreateQueryCsv = function (pair) {
        return {
            key: pair.key,
            value: pair.value.join(",")
        };
    };
    UrlService.prototype.ReplaceValueInUrl = function (url, key, newValue) {
        var urlObj = this.GetObjectFromUrlString(url);
        urlObj[key] = newValue;
        return this.GetStringFromUrlObj(urlObj);
    };
    UrlService.prototype.isUrlToFile = function (url) {
        return !!url ? this.regexFileUrl.test(url) : false;
    };
    UrlService.prototype.GetFileExtension = function (url) {
        if (!url) {
            return null;
        }
        var ext = url.match(this.matchExtension);
        if (!ext || !ext.length) {
            return null;
        }
        return ext[2] || ext[1] || ext[0];
    };
    return UrlService;
}());
var service = new UrlService();
exports.UrlService = service;
